export default {
  sysTitle: "创新能管理系统",
  sysMenu: "系统管理",
  currentPosition: "当前位置",
  operatorId: "运营商代码",
  oprName: "运营商名称",
  tips: "提示",
  isDelete: "是否确认删除",
  deleteSuccess: "删除成功",
  updateSuccess: "修改成功",
  addSuccess: "新增成功",
  all: "全部",
  operation: "操作",
  dl: "电量",
  eleFee: "电费",
  serverFee: "服务费",
  delayFee: "延时费",
  totalAmount: "总金额",
  yuan: "THB",
  kWh: "度",
  unitOrder: "单",
  ac: "交流",
  dc: "直流",
  confirm: "确认",
  noData: "暂无数据",
  allCity: "全部城市",
  chargingStation: "充电站",
  merchant: "商户",
  operator: "运营商",
  chargingPile: "充电桩",
  year: "年",
  month: "月",
  day: "日",
  timeType: "类型",
  regularText: "正常",
  irregular: "异常",
  disabled: "禁用",
  operationSucess: "操作成功",
  saveSucess: "保存成功",
  exportSuccess: "导入成功",
  allSelect: "全选",
  toExamine: "审核",
  invalid: "作废",
  remark: "备注",
  nothing: "无",
  error: "错误",
  connectionFailure: "连接服务器失败",
  notSupport: "您的浏览器不支持",
  keyword: "关键字",
  reviewingMultipleRechargesForOneCard: "审核一卡多充",
  loadMore: "加载更多",
  pleaseSelect: "请选择",
  startSNPl: "请输入开始SN",
  endSNPl: "请输入结束SN",
  must12Digits: "必须12位数字",
  menuOperationAuthority: "菜单操作权限",
  audit: {
    approvalStatus: "审核状态",
    userName: "用户姓名",
    phoneNo: "手机号",
    applyTime: "申请时间",
    applyReason: "申请原因",
    applyStatusDesc: "审核状态",
    auditTime: "审核时间",
    action: "操作",
  },
  //单位
  unitText: {
    pen: "笔",
    yuan: "THB",
    hours: "时",
    people: "人",
    seat: "座",
    year: "年",
    month: "月",
    day: "日",
    ton: "吨",
    second: "次",
    full: "满",
    reduce: "减",
    give: "送",
    zhang: "张",
    individual: "个",
  },
  // form 里公用组件或者公用文字的
  formText: {
    startTime: "开始时间",
    endTime: "结束时间",
    export: "导出",
    exportLoading: "导出中...",
    exportNumber: "导出条数",
    exportPl: "导出条数不能少于等于0",
    exportError: "导出出错或者超时",
    allCity: "全部城市",
    selectGun: "充电枪",
    selectMch: "商户",
    selectSite: "充电站",
    selectPile: "充电桩",
    selectTime: "选择时间",
    selectTimePl: "请选择时间",
    selectOper: "运营商",
    downloadForm: "下载表格",
    intTips: "数值",
    beginTimeTips: "请选择开始时间",
    endTimeTips: "请选择结束时间",
    import: "导入",
    selectProvince: "请选择省",
    selectCity: "请选择市",
    selectArea: "请选择区",
    subSuccess: "操作成功",
    goBack: "返回",
    timeNull: "请选择时间",
    timeMax: "开始时间不能超过结束时间",
    time24: "近24小时",
    time7: "近7小时",
    time30: "近30小时",
    timeCustom: "自定义",
    uploadError: "请上传以下文件类型：",
    copySuccess: "复制成功",
    loginTimeOut: "登录过期,请重新登录",
  },

  directCurrent: "直流",
  alternatingCurrent: "交流",
  gunStatus: "枪口状态",
  gunStatusObj: {
    onLine: "在线",
    offLine: "离线",
    free: "空闲",
    connected: "插枪",
    charging: "充电",
    full: "充满",
    trouble: "故障",
    disabled: "禁用",
    booked: "预约",
  },

  //===========================按钮===========================
  search: "查询",
  updata: "修改",
  update: "修改",
  add: "新增",
  edit: "编辑",
  delete: "删除",
  allDel: "批量删除",
  close: "关闭",
  save: "保存",
  refresh: "刷新",
  back: "返回",
  export: "导出",
  import: "导入",
  submit: "提交",
  cancel: "取消",
  details: "详情",
  query: "查看",
  sure: "确定",
  copy: "复制",
  // 验证
  regular: {
    name: "名称",
    please: "请输入",
    pleaseSelect: "请输入",
    max: "不能超过",
    maxText: "个字符",
    min: "不能少于",
    numberABC: "只能由数字或者字母组成",
    numberABCs: "只能由数字+字母+下划线组成",
    tel: "请输入手机号码或者座机号码，6-15位",
    phone: "请输入电话",
    phonePl: "请输入手机号码",
    phonePl11: "请输入11位数字的手机号码",
    phoneError: "请输入正确格式的手机号码",
    int: "只能是整数数字",
    maxInput: "最多输入",
    minInput: "最少输入",
    unit: "位",
    maxNum: "不能大于",
    minNum: "不能小于",
    money: "金额",
    towDecimal: "最多保留两位小数",
    email: "请输入邮箱",
    emailPl: "邮箱不能超过",
    emailError: "请填写正确的邮箱",
  },
  //===========================云产品===========================

  // 登录
  login: {
    loginTitle: "创新能管理系统",
    userName: "用户名",
    password: "密码",
    loginBtn: "登录",
    userNamePl: "请输入用户名",
    passwordPl: "请输入密码",
    passwordError: "请输入6位以上的密码",
  },
  //权限配置
  role: {
    roleList: "角色列表",
    autoMenu: "权限菜单",
    autoConfig: "配置权限",
    roleName: "中文角色名称",
    thRoleName: "角色名称",
    enRoleName: "英文角色名称",
    roleType: "角色类型",
    roleDesc: "备注",
    createUserName: "创建人",
    createTime: "创建时间",
    modifyTime: "更新时间",
    addRole: "新增角色",
    upRole: "修改角色",
    roleTypePl: "请选择角色类型",
    moduleName: "菜单模块",
    checkRender: "权限一览",
  },
  // 用户管理
  user: {
    userManagement: "用户管理",
    globalSearch: "输入关键字搜索（用户名/角色/创建人）",
    system: "充电桩后台",
    resetPassword: "重置密码",
    userName: "用户名",
    fullName: "姓名",
    phone: "联系方式",
    objectName: "归属运营商",
    delUserConfirm: "确定删除选中的用户吗？",
    addUser: "新增用户",
    upUser: "修改用户",
    info: "基本信息",
    userPwd: "密码",
    confirmPassword: "确认密码",
    userPwdNull: "请输入密码",
    userPwdMin: "密码长度为6~18字符",
    userPwdError: "密码不能包含空格、制表符、换行符",
    userPwdTowError: "请确认新旧密码是否一致",
    queryUser: "查看用户",
    userRolePl: "请选择角色",
    newPassword: "新密码",
  },
  //日志
  log: {
    tab1: "操作日志",
    tab2: "登录日志",
    loginIp: "登录IP",
    loginTime: "登录时间",
    resultDesc: "操作详情",
    logGlobalSearch: "输入关键字搜索(用户名、登陆IP)",
    operationLogGlobalSearch:
      "输入关键字搜索(用户名称/模块名称/操作方法/客户端IP)",
    requestIp: "客户商IP",
    moduleName: "模块名称",
    methodDesc: "操作方法",
    operatorTime: "操作时间",
    responseCode: "操作详情",
  },
  // 在线用户
  onlineuser: {
    globalSearch: "请输入关键字(用户名/登录名/IP地址)",
    offline: "强制下线",
    offlineConfirm: "确定要强制下线吗?",
    userFullName: "角色名",
    ipAddress: "IP地址",
    loginTime: "登录时间",
  },
  // 典表
  dictionary: {
    globalSearch: "输入关键字搜索(典表名称)",
    add: "新增典表",
    updata: "修改典表",
    items: "项",
    child: "子项",
    read: "只读",
    addOp: "增删改",
    edit: "编辑",
    typeName: "典表名称",
    typePkId: "key值",
    itemList: "典表项",
    typeFlag: "典表项状态",
    typeFlagPl: "请选择典表项状态",
    remark: "备注",
    modifyTime: "更新时间",
    // 子页面
    itemsManage: "典表项管理",
    childGlobalSearch: "输入关键字搜索(典表项名称)",
    rise: "上升",
    decline: "下降",
    itemValue: "典表项名称",
    englishName: "典表项英文名称",
    thName: "典表项泰文名称",
    itemKey: "key值",
    itemKeyPl: "请选择典表Key",
    flag: "状态",
    normal: "正常",
    disable: "停用",
  },
  // 系统升级
  systemNotice: {
    add: "新增系统升级",
    upgradeContent: "系统升级内容",
    upgradeTime: "系统升级时间",
    version: "版本",
    versionPl: "请输入版本号",
    upgradeContentPl: "请输入系统升级内容",
    upgradeTimePl: "请选择系统升级时间",
    updata: "修改系统升级",
  },
  // 模板文件
  modelFile: {
    add: "新增模板文件",
    templateFile: "模板文件",
    fileName: "文件名",
    pkid: "文件主键",
    createUserId: "创建人",
    createTime: "创建时间",
    attachmentPkId: "附件主键",
    modifyUserId: "修改人",
    modifyTime: "修改时间",
    businessType: "业务类型",
    fileType: "文件类型",
    templatePkId: "文件模板主键",
    attachmentPkIdPl: "请上传模板文件",
    businessTypePl: "请输入业务类型",
    fileNamePl: "请输入文件名称",
    fileTypePl: "请选择文件类型",
    remarkPl: "请输入备注",
    updata: "修改模板文件",
    lang: "语言",
    langPl: "请选择语言",
  },
  // 菜单
  menuList: {
    roleType: "系统",
    child: "子项",
    moduleName: "菜单名称",
    englishName: "菜单英文名称",
    thailandName: "菜单泰文名称",
    privilegeVoList: "权限",
    icon: "菜单图标",
    sort: "权重",
    url: "链接",
    activeMenu: "高亮路由路径",
    hidden: "隐藏",
    cacheName: "缓存名称",
    alwaysShow: "是否总是显示",
    component: "路由路径",
    yes: "是",
    no: "否",
    componentPl: "请输入路由路径",
    cacheNamePl: "请输入缓存名称",
    moduleNamePl: "请输入名称",
    englishNamePl: "请输入英文名称",
    thailandNamePl: "请输入泰文名称",
    urlPl: "请输入链接",
    addChild: "新增子菜单",
    updata: "修改子菜单",
    add: "新增菜单",
    auto: "权限选择",
    addAuto: "新增权限",
    privilegePl: "请选择权限",
  },
  //停止原因
  stopReason: {
    allConfig: "批量设置",
    add: "新增停止原因",
    stopCode: "停止代码",
    stopName: "停止原因",
    duty: "责任分配",
    addRow: "添加一行",
    updata: "修改停止原因",
    stopCodePl: "请输入停止代码",
    stopNamePl: "请输入停止名称",
    responsibilityTypePl: "请选择责任分配",
    configDataPl: "请选择要配置的数据",
    configSuccess: "配置成功",
    responsibilityType: "责任分布",
  },
  // 告警配置
  alarmSet: {
    allConfig: "批量配置",
    add: "新增告警配置",
    updata: "修改告警配置",
    alarmLevel: "告警等级",
    alarmType: "告警类型",
    faultName: "故障名",
    faultCode: "故障代码",
    faultTipMsg: "用户提示信息",
    type: "告警类型",
    addRow: "添加一行",
    faultCodePl: "请输入故障代码",
    faultTipMsgPl: "请输入用户提示信息",
    alarmLevelPl: "请选择告警等级",
    alarmTypePl: "请选择告警类型",
    configDataPl: "请选择要配置的数据",
    configSuccess: "配置成功",
    solution: "解决方法",
    solutionPl: "请输入解决方法",
    faultNamePl: "请输入故障名",
    faultEnName: "故障名英文",
    faultEnNamePl: "请输入英文名称",
    faultTipEnMsg: "用户提示信息英文",
    faultTipEnMsgPl: "请输入用户提示信息英文",
  },
  // kafka 日志
  kafkaLog: {
    globalSearch: "输入关键字搜索(主题)",
    partition: "分区",
    createTime: "创建时间",
    startOffset: "offset范围查询最小值",
    endOffset: "offset范围查询最大值",
    consumption: "重新消费",
    allConsumption: "批量重新消费",
    allConsumptionConfirm: "确定要重新消费所选中的吗?",
    allDel: "批量删除",
    allDelConfirm: "确定要删除所选中的吗?",
    topic: "主题",
    topicInfo: "消费主题信息",
    requestParam: "请求参数",
    reason: "错误信息",
  },
  // 订单校验配置
  orderConfig: {
    allOpen: "批量开启",
    allOpenConfirm: "确定要批量开启所选中的吗?",
    allClose: "批量关闭?",
    allCloseConfirm: "确定要批量关闭所选中的吗?",
    open: "已开启",
    close: "已关闭",
    enabled: "是否开启校验",
    faultName: "错误名称",
    faultCode: "错误代码",
    faultDesc: "错误简述",
    faultTypeDesc: "错误类型描述",
  },
  // 告警配置
  alarmsetting: {
    tab1: "设备告警批量设置",
    tab2: "设备告警逐条设置",
    tab3: "SIM流量告警设置",
    set: "设置",
    alarmLevel: "告警等级",
    faultCode: "故障代码",
    faultName: "故障描述",
    flow: "流量阀值",
    setLevel: "设置告警等级",
    alarmLevelName: "告警等级",
  },
  // 费率管理
  ratamanage: {
    tab1: "系统费率模板",
    tab2: "运营商费率模板",
    templateName: "模板名称",
    updateTime: "更新时间",
    jian: "尖",
    feng: "峰",
    ping: "平",
    gu: "谷",
    acRate: "交流桩充电费率（电费/服务费）",
    dcRate: "交流桩充电费率（电费/服务费）",
    delayRate: "延时费费率",
    bindStaNum: "使用数量(个)",
    modifyTime: "创建时间",
    rateDetails: "费率详情",
    delayRateDetails: "延时费费率详情",
    slotDelayPrice: "费率(THB/分钟)",
    ent: "企业",
    bindSta: "关联站点",
    stationName: "站点名称",
    stationAddress: "站点地址",
    index: "序号",
  },
  //新增费率
  addRatamanage: {
    feeName: "模板名称",
    rate: "充电费率",
    delayFreeMinutes: "免费时长(分钟)",
    add: "新增系统费率模板",
    addOper: "新增运营商费率模板",
    feeNamePl: "请输入模板名称",
    acRate: "交流桩费率",
    dcRate: "直流桩费率",
    delayRate: "延时费费率",
    slotFlag: "电价类型",
    slotElecPrice: "电价(THB)",
    slotServicePrice: "服务费(THB/kWh)",
    timeValue: "时间段",
    pricePl: "价格请输入数字",
    priceMax: "当前价格不能超过",
    selectTimePl: "请选择时间再添加",
    timeNoSelect: "24小时已全部选择，不能再添加",
    timeError: "时间段重叠，请检查",
    timeNoSelectSuccess: "请选择完整的24小时",
    slotElecPriceMax: "电价价格不能超过",
    slotServicePriceMax: "服务费价格不能超过",
    please: "请输入",
    slotDelayPrice: "费率（THB/分钟）",
  },
  // 设备型号
  equipmentModel: {
    deviceType: "设备类型",
    updateTime: "更新时间",
    globalSearch: "设备型号/生产商",
    deviceModelName: "设备型号",
    addSn: "设备SN区间",
    number: "数量",
    standard: "标配信息",
    matching: "选配信息",
    manufacturerName: "生产商",
    delDeviceModelName: "确定删除所选择设备型号吗？",
    minSelectItem: "请至少选择一项目",
    factoryInfo: "厂商信息",
    manufacturerPkId: "生产商名称",
    matchingAdd: "选配新增项",
    optionName: "选项名称",
    remark: "选项说明",
    addDeviceModel: "添加设备型号",
    deviceModelNamePl: "请输入设备型号",
    manufacturerPkIdPl: "请选择生产商名称",
    optionNamePl: "请输入选项名称",
    isChecked: "是否标配",
    optionValue: "固定值",
    deviceModelDetails: "设备型号详情",
    updataDeviceModel: "修改设备型号",
    optionValueError: "已勾选标配项固定值不能为空",
    deviceTypeInfo: "型号信息",
    deviceTypePl: "请选择设备类型",
    deviceModelPkIdPl: "请选择设备型号",
    optionEnName: "英文名称",
    optionEnNamePl: "请输入英文名称",
    remarkEn: "英文选项说明",
    remarkEnPl: "请输入英文选项说明",
  },
  // 设备清单
  equipmentList: {
    sns: "设备SN",
    snsPl: "sn，多个用逗号隔开",
    allSns: "批量",
    isBindOper: "配属状态",
    projectName: "归属项目",
    maintenanceMethodsType: "维护方式",
    export: "导入设备",
    add: "添加设备",
    relation: "关联",
    disassociate: "取消关联",
    disassociateConfrim: "确定要取消关联所选择的设备吗?",
    delConfirm: "确定要删除所选择的设备吗?",
    unattached: "未配属",
    attached: "已配属",
    serialNumber: "设备SN",
    gunNum: "枪口数",
    belongInfo: "配属信息",
    //导入
    import: "选择导入文件",
    importTpl: "导入模板",
    importTplDownload: "导入模板下载",
    total: "本次共计",
    dev: "台设备",
    dc: "直流桩",
    ac: "交流桩",
    protocolPkId: "协议",
    protocolPkIdPl: "请选择协议",
    //详情
    detailsTitle: "设备详情",
    dataDetails: "参数详情",
    manufacturerName: "生产厂家",
    // 关联
    typeNumber: "型号设备数量",
    changeModel: "更换型号",
    bindDev: "关联设备",
    unBindDev: "待关联设备",
    changeOper: "更换运营商",
    noChangeOper: "待更换设备",
    bindOper: "关联运营商",
    operPl: "请选择运营商",
    deviceModelPl: "请选择设备",
    //新增
    addSn: "设备SN区间",
    quantity: "数量",
    addBtn: "添加",
    snNull: "设备SN不能为空",
    snInt: "设备SN必须为数字",
    // 修改密码
    editPwd: "修改密码",
    selectStation1: "已选择",
    selectStation2: "个充电桩",
    customPassword: "自定义密码",
    customPasswordTip: "所选的充电桩统一设置为此密码",
    randomPassword: "随机密码",
    randomPasswordTip: "自动为每个充电桩生成6位随机密码",
    pwdPl: "请输入4-8位数字密码",
    pwdSucc: "操作成功,请等待3分钟后，查询结果。",
    passwordModificationRecord: "密码修改记录(近5条)",
    currentPassword: "当前密码",
    password: "密码",
    updateTime: "修改时间",
    status: "状态",
    lastSuccessful: "密码修改成功最后时间",
  },
  // 设备厂商
  producer: {
    busLicenseNumber: "营业执照编号",
    brandName: "品牌名称",
    manufacturerName: "设备生产商",
    manufacturerId: "设备生产商组织机构代码",
    contactName: "联系人",
    phoneNo: "联系方式",
    legalPerson: "公司法人",
    legalIdCard: "法人身份证",
    busLicenseNumberPl: "请输入营业执照编号",
    busLicenseNumberMax: "营业执照编号长度是18位",
    brandNamePl: "请输入品牌名称",
    manufacturerNamePl: "请输入设备生产商",
    manufacturerIdPl: "请输入设备厂商组织机构代码",
    manufacturerIdMax: "营业执照编号长度是九位",
    legalPersonPl: "请输入公司法人",
    legalIdCardPl: "请输入法人身份证",
    legalIdCardMax: "法人身份证长度是十八位",
    contactNamePl: "请输入联系人",
    add: "增加设备生产商",
    updata: "修改设备生厂商",
  },
  // 运营商
  oper: {
    operData: "运营商数量",
    operTotal: "运营商总数",
    accData: "帐号到期分析",
    globalSearch: "输入关键字搜索(运营商名称/运营商简称)",
    oprStatus: "运营状态",
    expireDays: "到期日期",
    customMade: "定制",
    msgConfig: "短信配置",
    phoneConfig: "自定义配置",
    functionalConfig: "功能性配置",
    gunLimit: "枪口上线",
    invoice: "发票",
    carInfo: "车辆信息",
    customizedChargingStrategy: "自定义充电策略",
    day30: "30天到期",
    day60: "60天到期",
    day90: "90天到期",
    companyName: "运营商简称",
    userName: "管理员帐号",
    deviceCount: "设备数量(台)",
    createTime: "创建时间",
    delOper: "确定删除运营商吗？",
    expireTime: "到期时间",
    //短信配置
    msgServer: "短信服务",
    agent: "短信服务商",
    pilot: "创新能",
    operMsg: "运营商自有",
    signName: "短信签名",
    "201": "充电开始通知",
    "203": "充电结束通知",
    "202": "充电结算通知",
    "301": "故障通知",
    "204": "余额不足提醒",
    "101": "登录短信模版",
    "104": "身份验证模版",
    "102": "修改密码模版",
    "103": "信息变更模版",
    agentPl: "请选择代理商",
    signNamePl: "请输入签名",
    please: "请输入",
    //新增运营商
    addOper: "运营商基础信息",
    operatorId: "组织机构代码",
    operMax: "请输入字符不能超过30个",
    companyNameMax: "10个字符以内",
    address: "详细地址",
    addressPl: "请输入详细地址",
    region: "区域",
    addressPlCity: "请选择区域",
    description: "公司描述",
    contactPerson: "联系人",
    tel: "联系电话",
    serviceTel: "客服电话",
    contactsMail: "联系人邮箱",
    oprSystemName: "运营商系统名称",
    oprSystemLogoFilePath: "系统LOGO",
    operTime: "运营期限",
    activeTime: "生效时间",
    allTime: "永久",
    add: "新增运营商",
    updata: "修改运营商",
    query: "查看运营商",
    rolePkIdPl: "请选择运营商角色",
    oprSystemLogoFilePathPl: "请上传运营商系统LOGO",
    qrCodeFilePathPl: "请上传二维码",
    mchCertFilePathPl: "请上传申请退款证书",
    logoPl: "请上传logo",
    activeTimePl: "请选择生效时间",
    zfbNamePl: "请输入短信签名",
    // 定制
    customTitle: "定制功能",
    gunQrCodeType: "充电桩枪口二维码链接",
    gunQrCodeTypePl: "请选择类型",
    gunQrCodeType1: "互联互通方式",
    gunQrCodeType2: "公众号链接方式",
    gunQrCodeTypeTextP1: "1、运营商创建后单独配置定制功能",
    gunQrCodeTypeTextP2: "2、枪口二维码默认互联互通方式，即当前的二维码模式",
    gunQrCodeTypeTextP3: "3、公众号链接方式为扫描枪口二维码带公众号链接模式",
    accTime: "账号到期分析",
    loginInfo: "运营商登录信息",
    loginUrl: "登录信息",
    loginName: "登录账号",
    loginPasswd: "登录密码",
    tips: "注：请保存好登录信息，若遗忘密码请点击重置；",
    resetPassword: "重置密码",
    close: "关闭",
    copy: "快速复制",
    loginPassword: "登录密码",
    iosAppDownloadLink: "ios下载链接",
    androidAppDownloadLink: "安卓下载链接",
    website: "官网地址",
    //移动端配置
    creditPayment: "信用支付",
    valueAddedFeatures: "增值功能",
    notificationMethodUser: "个人用户通知方式",
    notificationMethodOperatorsser: "运营商通知方式",
    passwordVerificationForOperatorModification: "运营商修改操作密码验证",
    registrationAndLoginConfiguration: "注册登录配置",
    verificationMethod: "验证方式（注册/忘记密码/修改密码）",
    registrationsSkipPasswordSetting: "新注册是否可跳过密码设置",
    passwordLoginMethod: "密码登录方式",
    defaultLoginMethod: "默认登录方式",
    prioritySMS: "优先短信 ",
    priorityEmail: "优先邮件",
    SMS: "短信",
    email: "邮件",
    passwordVerification: "密码验证",
    sMSVerification: "短信验证",
    sMSVerificationCode: "短信验证码",
    emailVerificationCode: "邮箱验证码",
    phoneNumberPassword: "手机号密码",
    emailPassword: "邮箱密码",
    verificationCodeLogin: "验证码登陆",
    PasswordLogin: "密码登录",
    rechargeCashier: "充值收银台",
    selfBuiltCashRegiste: "自建收银台",
    hirdPartyCashRegister: "第三方收银台",
    cash: "现金",
    paymentChannel: "支付方式",
    paymentChannelPl: "请选择支付方式",
    channelPartners: "渠道商",
    channelPartnersPl: "请选择渠道商",
    plugAndCharge: "即插即充",
    creditCard: "银行卡",
  },

  //运营商账号
  operAccount: {
    reconciliation: "手动平账",
    abnormalSum: "异常数量",
    result: "对帐结果",
    accDetails: "账户详情",
    details: "对帐详情",
    formula: "对比账户",
    abnormalReason: "对比详情",
    leftAmount: "左边钱",
    rightAmount: "右边钱",
    money: "差额",
    accountType: "账户类型",
    accountPkId: "账户号",
    balanceAmount: "余额",
    orderNo: "充电订单号",
    orderNoPl: "请输入充电订单号",
    userCorrectAmount: "个人用户账户冲抵金额",
    userCorrectAmountPl: "请输入个人用户账户冲抵金额",
    prepayCorrectAmount: "托管账户冲抵金额",
    prepayCorrectAmountPl: "请输入托管账户冲抵金额",
    chargeCorrectAmount: "充电账户冲抵金额",
    chargeCorrectAmountPl: "请输入充电账户冲抵金额",
    password: "操作密码",
    passwordPl: "请输入操作密码",
  },
  // 发布通知
  postNotice: {
    globalSearch: "标题模糊检索",
    publish: "发布",
    publishConfirm: "确定要发布吗?",
    withdraw: "撤回发布",
    withdrawConfirm: "确定要撤回发布吗?",
    title: "通知标题",
    titlePl: "请输入通知标题",
    content: "通知内容",
    contentPl: "请输入通知内容",
    createTime: "创建时间",
    publishTime: "发布时间",
    publishStatus: "发布状态",
    email: "邮件通知",
    emailPl: "请选择邮件通知",
    open: "开启",
    close: "关闭",
    add: "新增发布",
    operPl: "请选择运营商",
    details: "发布详情",
    updata: "修改发布",
  },
  // 互联互通
  auditHlhtSystem: {
    netDriection: "互通方向",
    netStatus: "审核状态",
    globalSearch: "关键字",
    netFileName: "下载附件",
    audit: "审核",
    auditModal: "审核互联互通",
    yes: "通过",
    no: "不通过",
    systemName: "系统名称",
    reason: "申请理由",
    netType: "互通类型",
    beginTime: "开始时间",
    endTime: "结束时间",
    contactName: "联系人",
    phoneNo: "联系方式",
  },
  //增值服务
  addValueService: {
    serviceName: "服务名称",
    logo: "服务logo",
    hasOpen: "开放状态",
    add: "新增增值服务",
    enable: "启用",
    disabled: "禁用",
    logoPl: "请上传文件",
    hasOpenPl: "请选择状态",
  },
  //参数配置
  dataConfig: {
    tab1: "电费配置",
    tab2: "二维码配置",
    connectLoading: "连接通迅中.....",
    connectClose: "连接中断或者连接已关闭",
    reconnect: "重新连接",
    realTimeMsg: "实时报文",
    clear: "清除",
    gunPkIdPl: "请选择枪口",
    subscribeSuccess: "订阅成功",
    pilePkId: "桩编号",
    pilePkIdPl: "请选择桩",
    gunPkId: "枪编号",
    ratedVoltage: "额定电压",
    ratedCurrent: "额定电流",
    ratedPower: "设备功率",
    // 报文
    reply: "回复",
    get: "请求",
    pile: "桩",
    platform: "平台",
    pileData: "桩 数据",
    platformData: "平台 数据",
    // 二维码
    rateName: "二维码",
    rateNamePl: "请输入二维码字符串",
    getBtn: "召测",
    issue: "下发二维码",
    send: "发送",
    clickSend: "点击发送",
    response: "响应",
    issueSuccess: "下发成功",
    //电费配置
    ratePkid: "费率",
    rateTpl: "费率模板名称",
    acRate: "交流桩费率",
    pileRate: "桩费率",
    platformRate: "平台费率",
    slotFlag: "电价类型",
    slotElecPrice: "电价(THB/kWh)",
    slotServicePrice: "服务费(THB/kWh)",
    time: "时间段",
  },
  // 充电操作
  chargingOperation: {
    status1: "空闲",
    status2: "已插枪",
    status3: "启动充电",
    status4: "充电中",
    status5: "等拔枪",
    tab1: "充电上报数据",
    tab2: "BMS上报数据",
    tab3: "充电报告数据",
    startCharging: "启动充电",
    msgType1: "实时",
    msgType2: "历史",
    time: "通讯时间",
    loadMore: "加载更多",
  },
  // 运维数据
  operData: {
    tab1: "设备登录",
    tab2: "设备心跳",
    tab3: "故障上报",
    tab4: "升级",
    upgrade: "升级",
    202: "升级包版本",
    1009: "最大充电功率",
    1007: "最大充电电流",
    513: "SIM卡ICCID",
    1003: "禁止/允许离线充电",
    2024: "SIM卡信号强度",
    100: "联网方式",
    1010: "二维码",
    58: "复费率单价版本号",
    sendSuccess: "指令已发送，看看设备状态吧",
    allow: "允许",
    prohibit: "禁止",
    ethernet: "以太网",
    host: "主机Ip地址",
    port: "主机端口",
    userName: "FTP用户名",
    password: "FTP用户密码",
    fileDir: "文件目录",
    success: "升级成功",
  },
  // 短信管理
  messageManage: {
    msgTitle: "短信池",
    rechange: "充值",
    remaining: "剩余可用条数(条)",
    used: "已用条数(条)",
    top5: "剩余可用条数top5",
    unit: "条",
    remainingMin: "剩余条数最小值",
    remainingMax: "剩余条数最大值",
    usedMin: "已用条数最小值",
    usedMax: "已用条数最大值",
    recordBtn: "短信记录",
    rechargeBtn: "短信充值",
    totalNum: "已购买条数",
    sentNum: "已用条数",
    addNum: "增加条数",
    remainNum: "剩余条数",
    comboPkId: "购买条数",
    paymentAmount: "支付金额",
    msgRechange: "短信充值",
    comboPkIdPl: "请选择短信条数",
  },
  // 短信记录
  messageRecord: {
    tab1: "购买记录",
    tab2: "发送记录",
    pkid: "订单号",
    purchasedWay: "购买方式",
    auditStatus: "订单状态",
    attachmentUrl: "附件",
    downloadAttachmentUrl: "下载附件",
    audit: "审核",
    createUserName: "操作人员",
    purchasedCount: "购买数量（条）",
    paymentAmount: "支付金额",
    createTime: "购买时间",
    phoneNo: "手机号码",
    agent: "发送类型",
    bussType: "业务类型",
    pilot: "创新能",
    aliCloud: "阿里云",
    sendTime: "发送时间",
    content: "发送内容",
    status: "发送状态",
    auditAction: "审核状态",
    oprSystemLogoFilePath: "上传附件",
    msgAudit: "短信审核",
    auditActionPl: "请选择审核状态",
    oprSystemLogoFilePathPl: "请上传附件",
    auditAction1: "通过",
    auditAction2: "拒绝",
  },
  // 短信定价
  messagePrice: {
    number: "短信条数",
    price: "套餐价格",
    contactPhone: "联系人手机号",
    status: "状态",
    rechargeContact: "充值联系人",
    rechargeTips:
      "修改联系人信息将同步修改其它短信条数套餐联系信息，请谨慎修改",
    qrCodeFilePkId: "联系人微信",
    qrCodeFilePkIdTips: "上传二维码,支持.jpg .jpeg .png",
    qrCodeFilePkIdPl: "请上传联系人微信",
    updata: "修改定价",
    add: "新增定价",
    close: "关闭",
    closeConfirm: "确定要关闭吗?",
  },
  // license管理
  cardClient: {
    projectName: "项目名称",
    updataTime: "更新时间",
    queryCode: "查看客户编码",
    licenseBtn: "Licence管理",
    createUserName: "创建人",
    activatedAmount: "已激活条数",
    projectCode: "客户编码",
    modifyTime: "下载Licence文件",
    moduleNames: "Licence模块",
    machineCode: "序列号",
    pileNumber: "桩数",
    status: "状态",
    beginTime: "生效日期",
    endTime: "到期日期",
    add: "新增项目",
    projectNamePl: "请输入项目名称",
    projectCodeMax: "客户编码必须是8位数字",
    modulePkIdsPl: "请选择Licence模块",
    machineCodePl: "请输入序列号",
    beginTimePl: "请选择生效日期",
    endTimePl: "请选择到期日期",
    addLicence: "新增Licence",
    updataLicence: "修改Licence",
    timeMax: "生效日期不能超过到期日期",
  },
  // SIM卡管理
  simOutTest: {
    projectName: "项目名称",
    keywords: "关键字",
    pileNoOrIccidPl: "设备编号/ICCID",
    applicantOrCaller: "申领人/召测人",
    simStatus: "SIM卡状态",
    createTime: "创建时间",
    recallTest: "SIM卡召测",
    claim: "SIM卡申领",
    batchSync: "批量同步",
    sync: "同步",
    applicant: "申领人",
    caller: "召测人",
    outgoer: "出库人",
    modifyTime: "更新时间",
    simStatusPl: "请选择SIM卡状态",
    serialNumber: "设备编号",
    applyTitle: "申领SIM卡",
    iccid: "SIM卡编号",
    iccidTips: "请输入，限100字",
    importFile: "导入文件",
    downloadTpl: "下载模板",
    simSum: "SIM卡数量",
    applicantPl: "请输入申领人",
    iccidPl: "请输入SIM卡编号",
    outgoerPl: "请输入出库人",
    snStartNo: "输入开始编号",
    snEndNo: "输入结束编号",
    match: "匹配",
    projectNamePkId: "关联项目",
    saveExport: "保存并导出",
    modalTitle: "SIM卡召测",
  },
  // 生产任务单
  productionOrder: {
    step0: "流程开始",
    step1: "第一步",
    step2: "第二步",
    step3: "第三步",
    step4: "流程结束",
    content0: "新增任务单",
    content1: "开始生产",
    content2: "设备入库",
    content3: "品质核检",
    content4: "设备发货",
    keyword: "关键字",
    numOrProject: "合同单号/项目名称",
    modelName: "设备型号",
    productionStatus: "生产状态",
    createTime: "创建日期",
    syncDev: "同步设备",
    start: "开始生产",
    void: "作废",
    changePriority: "调整优先级",
    warehousing: "设备入库",
    check: "品质核捡",
    ship: "设备发货",
    index: "序号",
    priority: "优先级",
    orderType: "任务单类型",
    contractBillNumber: "合同单号",
    projectName: "项目名称",
    platformModel: "平台型号",
    pileNum: "设备数量",
    doneModelNum: "已发货数",
    warehousingConfirm: "确定要入库吗?",
    delConfirm: "确定要删除该生产单吗?",
    voidConfirm: "确定要作废该生产单吗?",
    startConfirm: "确定要开始生产吗?",
    //新增
    projectInfo: "项目信息",
    contractBillNumberPl: "请选择合同单号",
    priorityPl: "请选择优先级",
    projectNamePl: "请选择项目名称",
    devInfo: "设备信息",
    materialNumber: "成品物料编码",
    materialNumberPl: "请输入成品物料编码",
    clientNum: "客户编码",
    clientNumPl: "请输入客户编码",
    deviceModelPkId: "设备型号",
    deviceModelPkIdPl: "请选择设备型号",
    platformModelPl: "请选择平台型号",
    deviceNo: "设备编号",
    deviceStartNo: "开始设备编号",
    deviceEndNo: "结束设备编号",
    quantity: "设备数量",
    motherboard: "主板",
    motherboardPl: "请输入主板",
    interfaceBoard: "接口版",
    interfaceBoardPl: "请输入接口版",
    displayScreen: "显示屏",
    displayScreenPl: "请输入显示屏",
    requirements: "定制和生产要求",
    requirementsPl: "请输入定制和生产要求",
    inputMaxPl: "请输入，限100字",
    equipmentRemarks: "设备备注",
    equipmentRemarksPl: "请输入设备备注",
    adds: "继续添加",
    issuerAndCard: "发卡器+IC卡",
    issuerAndCardPl: "请输入发卡器+IC卡",
    remark: "任务单备注",
    remarkPl: "请输入任务备注",
    verificationInfo: "核检信息",
    verifier: "核检人",
    checkContent: "核检内容",
    shippingInfo: "出货信息",
    deliveryRequirements: "发货要求",
    logisticsAndNumber: "物流及单号",
    inspectionAndSignature: "巡检及出货检签名",
    shippingCardIssuerICCard: "发卡器+IC卡",
    shippingCardIssuerICCardPl: "请输入发卡器+IC卡",
    orderTypePl: "请选择任务单类型",
    add: "新增任务单",
    updata: "修改任务单",
    details: "任务单详情",
    other: "其他信息",
    deliveryRequirementsPl: "请输入发货要求",
    logisticsAndNumberPl: "请输入物流及单号",
    inspectionAndSignaturePl: "请输入巡检及出货检签名",
    verifierPl: "请输入核检人",
    checkContentPl: "请输入核检内容",
  },
  //销售订单
  salesOrder: {
    globalSearch: "合同单号/项目名称/销售员",
    sellerName: "销售员",
    specificationModel: "规格型号",
    month: "预计发货",
    monthPl: "请选择预计发货",
    deliveryTime: "发货时间",
    shipConfirm: "确定要发货吗?",
    childTitle: "子项目-产品信息",
    number: "数量",
    requirementDesc: "需求描述",
    requirementDescPl: "请输入需求描述",
    shippingAddress: "发货地址",
    shippingAddressPl: "请输入发货地址",
    add: "新增销售订单",
    contractBillNumberPl: "请输入合同单号",
    specificationDetails: "请输入规格型号",
    specificationDetailsPl: "请输入规格型号",
    sellerNamePl: "请输入销售员",
    month1: "一月",
    month2: "二月",
    month3: "三月",
    month4: "四月",
    month5: "五月",
    month6: "六月",
    month7: "七月",
    month8: "八月",
    month9: "九月",
    month10: "十月",
    month11: "十一月",
    month12: "十二月",
  },
  // 头部
  header: {
    clickGo: "点击跳转",
    out: "退出登录",
    outConfirm: "确定要退出登录吗？",
    unit: "条",
  },
  // 设备档案
  reportFile: {
    pageTitle: "报告档案",
    deviceArchivePkId: "档案ID",
    deviceTypeName: "设备类型",
    manufacturerName: "生产厂商",
    deviceModelName: "设备型号",
    deviceModelRatedPower: "额定功率",
    deviceModelChargeStandardName: "设备标准",
    archiveCode: "报告编号",
    feelerMechanismName: "测试机构",
    archiveCreateDate: "报告生成日期",
    attachmentRecordPkId: "型式试验报告",
    entryDate: "录入日期",
    deviceRatedPower: "功率范围(kW)",
    query: "点击查看",
    change: "更换报告",
    updataTitle: "请选择文件",
    minDeviceRatedPowerError: "功率范围最小值不能小于0",
    maxDeviceRatedPowerError: "功率范围最大值不能小于0",
    minMaxDeviceRatedPowerError: "功率范围最大值不能小于最小值",
  },
  // 站点规模配置
  siteSizeConfig: {
    smallSizeStaNum: "小规模",
    mediumSizeStaNum: "中规模",
    largeSizeStatNum: "大规模",
    configName: "配置名称",
    pileNum: "桩数量（台）",
    power: "功率（kw）",
    min: "小于",
    max: "大于",
    updataTitle: "修改站点规模配置",
    maxTips: "最大值不能小于最小值:",
    maxPile: "桩最大值",
    minPile: "桩最小值",
    maxPower: "功率最大值",
    minPower: "功率最小值",
  },
  appUpdate: {
    addUpgradeReminder: "添加升级提醒",
    editUpgradeReminder: "编辑升级提醒",
    operatorNameAbbreviation: "运营商名称/简称",
    type: "类型",
    status: "状态",
    upgradeCopy: "升级文案",
    thaiLanguage: "泰语",
    english: "英文",
    chinese: "中文",
    inValidContent: "继续操作将失效该规则？",
    msg: {
      error: "存在有运营商同类型的规则正在生效中，请先对原规则进行失效处理",
    },
    table: {
      compatibleOperator: "适配运营商",
      type: "类型",
      mandatoryUpgradeVersion: "强制升级版本号",
      remindUpgradeVersion: "升级提醒版本号",
      remarks: "备注",
      updateTime: "更新时间",
      status: "状态",
      operation: "操作",
      addUpgradeNotification: "添加升级提醒",
      effective: "生效",
      ineffective: "失效",
      pendingActivation: "待生效",
    },
    rules: {
      appType: "请选择手机类型",
      oprType: "请选择运营商",
      remindUpgradeVersion: "请输入升级提醒版本号",
    },
  },
  paymentChannel: "支付方式",
  car: {
    addModel: {
      addTitle: "添加汽车",
      editTitle: "编辑汽车",
    },
    tips: {
      brandTips: "品牌为必填项",
      serialTips: "序列为必填项",
      modelTips: "型号为必填项",
      fuelTypeTips: "燃料类型为必填项",
    },
    operator: "运营商",
    timeSubmitted: "提交时间",
    carDirectory: "汽车目录",
    userFeedback: "用户反馈",
    brand: "品牌",
    series: "系列",
    model: "型号",
    region: "地区",
    powerMode: "电源模式",
    rank: "等级",
    type: "类型",
    seats: "座位",
    batteryCapacity: "电池容量（kWh）",
    mileage: "里程（km）",
    createDate: "创建时间",
    users: "用户数量",
    inputLimitDescription: "最多可输入4位数，小数点保留2位",
    inputPositiveInteger6DigitsMax: "请输入不超过6位数的正整数",
    globalSearch: "输入汽车型号",
  },
  countrycode: {
    add: "新增区号",
    edit: "编辑区号",
    areaCode: "区号",
    enName: "英文名称",
    zhName: "中文名称",
    locName: "本地语言名称",
    regRules: "正则校验规则",
    regRulesPl: "请输入正则校验规则",
    regRulesPl1: "请输入正确的正则校验规则",
  },
};
